import { formatProfessionnalName, getNameWithPrefix } from '@domain/utils';

import { State } from '@store/reducer';
import { selectSenderIdentities } from '@store/user/user.selector';
import { identitiesListToObject } from '@utils/identities.util';

export const selectDraftCurrentIdentityReference = (state: State) =>
  state.documentDraft?.dashboardView.currentIdentity;

export const selectDraftCurrentIdentity = (state: State) => {
  const ref = selectDraftCurrentIdentityReference(state);
  if (ref) {
    return identitiesListToObject(selectSenderIdentities(state))[ref];
  }
  return undefined;
};

export const selectFormatedDraftCurrentIdentity = (state: State) => {
  const identity = selectDraftCurrentIdentity(state);
  if (identity) {
    return {
      ...identity,
      name: getNameWithPrefix(formatProfessionnalName(identity)),
    };
  }
  return undefined;
};

export const selectDraftCounters = (state: State) => state.documentDraft.dashboardView.totalDraft;

/*
 * TTL CACHE SELECTORS
 */

// TTL for draft counters cache: 10 minutes
export const DRAFT_COUNTER_TTL = 10 * 60 * 1000;

/**
 * Checks if the draft counter cache is stale (needs refresh)
 * Returns true if:
 * - Counter has never been fetched (lastFetchedAt is undefined)
 * - Counter was fetched more than DRAFT_COUNTER_TTL ago
 */
export const selectIsDraftCounterStale = (state: State): boolean => {
  const { lastFetchedAt } = state.documentDraft.dashboardView.totalDraft;
  if (!lastFetchedAt) return true;
  return Date.now() - lastFetchedAt > DRAFT_COUNTER_TTL;
};
